import React, { useEffect } from 'react';

const AddressTextField = ({
  type,
  placeholder,
  className,
  register,
  validationMsg,
  onKeyDown,
  value,
  maxLength,
  style,
  readonly,
  id,
  autoComplete,
}) => {
  return (
    <>
      <input
        id={id}
        placeholder={placeholder}
        className={className}
        type={type}
        onKeyDown={onKeyDown}
        {...register}
        defaultValue={value}
        maxLength={maxLength}
        style={style}
        readOnly={readonly}
        autoComplete={autoComplete}
      />
      {validationMsg && (
        <>
          <span className="address1_error error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default AddressTextField;
